//服务协议
export const serviceAgreementData = `<div class="Section0" style="layout-grid: 15.6pt">
  <p
    class="MsoNormal"
    align="center"
    style="
      mso-pagination: widow-orphan;
      text-align: center;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 方正小标宋简体;
        color: rgb(0, 0, 0);
        font-weight: normal;
        font-size: 16pt;
        mso-font-kerning: 0pt;
      "
      ><font face="方正小标宋简体">易物流云平台用户服务协议</font></span>
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 方正小标宋简体;
        color: rgb(0, 0, 0);
        font-weight: normal;
        font-size: 16pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    align="center"
    style="
      mso-pagination: widow-orphan;
      text-align: center;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 方正小标宋简体;
        color: rgb(0, 0, 0);
        font-weight: normal;
        font-size: 12pt;
        mso-font-kerning: 0pt;
      "
      ><font face="方正小标宋简体">（运输货源发布方）</font></span
    >
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 0pt;
      mso-char-indent-count: 0;
      mso-pagination: widow-orphan;
      text-align: left;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 黑体;
        color: rgb(0, 0, 0);
        font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="黑体">欢迎您使用易物流云平台！</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    align="justify"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      text-align: justify;
      text-justify: inter-ideograph;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >为使用易物流云平台相关服务，您应当认真阅读并遵守本协议以及易派客电子商务平台与易物流云平台发布的各项规则、政策、声明、公告等相关内容与文件。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    align="justify"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      text-align: justify;
      text-justify: inter-ideograph;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">本协议是易派客电子商务有限公司（以下简称</font
      ><font face="仿宋_GB2312"
        >“易派客”）作为易派客电子商务平台、易物流云平台（以下简称“易物流”）的运营者和易物流相关服务的提供者，与运输货源发布方（以下统称“您”）就您使用易物流所订立的有效合约。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    align="justify"
    style="
      text-indent: 28.1pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      text-align: justify;
      text-justify: inter-ideograph;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">您点击或勾选本页面上的</font
        ><font face="仿宋_GB2312"
          >“同意”键或者以其他方式确认同意/接受本协议</font
        ></span
      ></b
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">（如在相关页面上点击后续操作</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">，</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">或已实际享有本协议项下的权益</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">，</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">或已实际接受易物流相关服务</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">，</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >或已实际执行本协议项下的部分约定等）</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >，即表示您与易派客已达成本协议并同意接受本协议全部约定内容的约束。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    align="justify"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      text-align: justify;
      text-justify: inter-ideograph;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >在确认本协议之前，请您务必审慎、仔细阅读并充分理解本协议的全部内容。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >如果您不同意本协议的任何内容，或者无法准确理解本协议任何条款的含义，请不要进行确认及后续操作。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        mso-ansi-font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">同意</font
      ><font face="仿宋_GB2312"
        >/接受本协议构成您使用易物流的先决条件，您的使用行为将视为同意/接受本协议各项条款的约束。</font
      ></span
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 微软雅黑;
          mso-bidi-font-family: 宋体;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 8pt;
          mso-font-kerning: 0pt;
        "
        ><o:p></o:p></span
    ></b>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 黑体;
        color: rgb(0, 0, 0);
        font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="黑体">一、定义</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 黑体;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    align="justify"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      text-align: justify;
      text-justify: inter-ideograph;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >本协议所称的相关术语，除另有约定以外，其定义如下：</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    align="justify"
    style="
      text-indent: 28.1pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      text-align: justify;
      text-justify: inter-ideograph;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">易派客电子商务平台：</font></span
      ></b
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >指由易派客电子商务有限公司运营的工业品电子商务平台，一级域名：</font
      ><font face="仿宋_GB2312">www.epec.com。</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    align="justify"
    style="
      text-indent: 28.1pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      text-align: justify;
      text-justify: inter-ideograph;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">易物流云平台：</font></span
      ></b
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >指由易派客电子商务有限公司运营的物流管理软件系统（含</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">网页端</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">和移动端）。</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    align="justify"
    style="
      text-indent: 28.1pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      text-align: justify;
      text-justify: inter-ideograph;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">用户：</font></span
      ></b
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >指已注册成为易派客电子商务平台会员，有权限使用易物流云平台相关功能和服务的运输货源发布方、物流服务商</font
      ><font face="仿宋_GB2312"
        >/承运人及其他使用易物流云平台的主体。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    align="justify"
    style="
      text-indent: 28.1pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      text-align: justify;
      text-justify: inter-ideograph;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">车货匹配功能：</font></span
      ></b
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >系易派客电子商务有限公司为使用易物流云平台的用户所提供的平台服务。运输货源发布方可通过易物流云平台车货匹配功能发布发运单，面向选定范围的物流服务商进行询价或由选定范围的物流服务商进行抢单，并从中选定货物承运人，开展后续的货物运输合作。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    align="justify"
    style="
      text-indent: 28.1pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      text-align: justify;
      text-justify: inter-ideograph;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">运输货源发布方：</font></span
      ></b
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >指通过易物流云平台车货匹配功能发布发运单，面向选定范围的物流服务商进行询价或由选定范围的物流服务商进行抢单并从中选定货物承运人，与相应承运人开展后续的货物运输合作的易物流云平台用户。</font
      > </span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    align="justify"
    style="
      text-indent: 28.1pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      text-align: justify;
      text-justify: inter-ideograph;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">物流服务商：</font></span
      ></b
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >指具备相应的货物运输能力，旨在提供货物运输服务的易物流云平台用户。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    align="justify"
    style="
      text-indent: 28.1pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      text-align: justify;
      text-justify: inter-ideograph;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">承运人：</font></span
      ></b
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >指通过易物流云平台车货匹配功能参与运输货源发布方进行的询价或抢单，而被运输货源发布方选定作为货物承运人，与运输货源发布方开展后续的货物运输合作的物流服务商，以及易派客电子商务平台注册的供应商通过易派客电子商务平台编制发货时直接指定作为货物承运人且接单确认的物流服务商。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    align="justify"
    style="
      text-indent: 28.1pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      text-align: justify;
      text-justify: inter-ideograph;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">用户信息：</font></span
      ></b
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">指用户提交给易派客电子商务平台及</font
      ><font face="仿宋_GB2312"
        >/或易物流云平台的、用户通过易派客电子商务平台及/或易物流云平台发布的、易派客电子商务平台及/或易物流云平台通过用户授权的第三方获取的用户相关信息，包括但不限于：用户的名称、电话号码等联系方式；用户的法定代表人/负责人/经营者/授权代表的姓名、电话号码等联系方式、身份证信息、授权委托书等；营业执照、道路运输经营许可证、车辆行驶证、驾驶证等许可、备案证明；车辆信息、货源信息、公司或仓库位置信息、货物运输轨迹信息；用户为申请、使用易派客电子商务平台及/或易物流云平台的合作方所提供的服务而提交的其他相关信息。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    align="justify"
    style="
      text-indent: 28.1pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      text-align: justify;
      text-justify: inter-ideograph;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">个人信息：</font></span
      ></b
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">《易派客隐私政策》中对</font
      ><font face="仿宋_GB2312"
        >“个人信息”的定义和范围适用于本协议。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    align="justify"
    style="
      text-indent: 28.1pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      text-align: justify;
      text-justify: inter-ideograph;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">车辆信息：</font></span
      ></b
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >指提供货物运输服务的车辆的相关信息，包括但不限于：车牌号、车牌类型、车型、车长、车宽、载重、车辆识别代码、发动机号、车厢信息、车厢体积、车厢长度、拖挂轮轴、车辆轴数信息。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    align="justify"
    style="
      text-indent: 28.1pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      text-align: justify;
      text-justify: inter-ideograph;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">货源信息：</font></span
      ></b
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >指与运输货物相关的信息，包括但不限于：货物名称、货物规格型号、总重量、重量单位、货物类型、货值单价、发货地址、收货地址、货物类型、发货时间、收货时间、货物体积</font
      ><font face="仿宋_GB2312">/重量/数量、特殊运输要求信息。</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    align="justify"
    style="
      text-indent: 28.1pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      text-align: justify;
      text-justify: inter-ideograph;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">车辆：</font></span
      ></b
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">指物流服务商</font
      ><font face="仿宋_GB2312">/承运人提供货物运输服务的货运车辆。</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    align="justify"
    style="
      text-indent: 28.1pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      text-align: justify;
      text-justify: inter-ideograph;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">注册司机：</font></span
      ></b
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">指物流服务商</font
      ><font face="仿宋_GB2312"
        >/承运人在易物流云平台注册的本单位具有依法从事货物运输业务相关资质，能够驾驶货运车辆提供货物运输服务的自然人。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      text-align: left;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 黑体;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="黑体">二、</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 黑体;
        color: rgb(0, 0, 0);
        font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="黑体">用户承诺及保证</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 黑体;
        color: rgb(0, 0, 0);
        font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >您在此不可撤销地作出如下承诺及保证，并充分理解和同意</font
      ><font face="仿宋_GB2312"
        >/认可将自行承担因违反下述承诺及保证而造成的全部损失：</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >2.1
        您必须是依据相关法律法规合法注册且有效存续，具备您所从事的经营活动的能力和资质，且信誉良好的法人或其他组织。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >2.2
        您具有订立和履行本协议的全部法律权利和能力。本协议规定的义务是对您合法、有效和有约束力的义务。您与易派客订立和履行本协议不会构成对任何文件、合同或适用法律的违约或违反。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >2.3
        您充分理解并明确同意：易物流仅为普通货物运输业务提供网络交易撮合、信息发布等平台服务，您不得要求物流服务商/承运人提供任何形式的非货运服务。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >2.4
        您充分理解并明确同意：对于需付费的易物流相关服务，易派客有权收取平台服务费用并有权单方面确定、调整具体的收费标准、收费方式等付费要求。易派客可能会给予您一定的免费体验付费服务的次数或期限，但易派客有权根据运营需要或使用情况等原因随时终止免费体验。免费体验终止后，您如需继续使用该付费服务，须按易派客公示的收费标准、收费方式等付费要求购买付费服务后方可继续使用。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >2.5
        您充分理解并明确同意：您在使用易物流过程中，应确保自身所发布、提供的用户信息均是合法、真实、准确、完整、有效的信息，且自身为该等信息的有权发布、提供方，并应确保在该等信息发生变更时及时更新，以持续确保所发布、提供的信息的合法性、真实性、准确性、完整性及有效性。否则，您应当就因此造成的损失承担全部赔偿责任，且易派客有权停止向您提供任何服务。若您发布的任何信息不符合相关法律法规、易派客电子商务平台或易物流的各项规则、政策、声明、公告等相关内容与文件要求，或不符合本协议有关约定的，或不符合您与易派客签署的其他相关用户协议的，易派客有权视情况要求您进行改正、完善、删除或采取其他措施。因您发布的任何信息给易派客或其他任何第三方造成损失的，您应当承担</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">全部</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >赔偿责任，易派客因此而遭受损失的，易派客有权向您追偿。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >2.6
        您充分理解并明确同意：易派客有权根据易派客电子商务平台、易物流的各项规则、政策、声明、公告等相关内容与文件要求、用户与易派客签署的相关协议约定、国家相关法律法规</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">规章以及</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">政策</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">等规范性文件要求</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >、有权部门的要求，要求您进一步提供相关信息，您应予以积极配合。如您未能积极配合或未能及时提供前述信息，易派客有权立即暂停或终止向您提供部分或全部易物流服务，并由您自行承担因此所造成一切损失，易派客不承担任何责任。</font
      ><font face="仿宋_GB2312">&nbsp;</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">2.7 您充分理解并</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">明确</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >同意：易派客对《易物流云平台运营规则》拥有解释权，有权不定时审查您在易物流上的行为，一旦发现您有违反易派客电子商务平台或易物流的各项规则、政策、声明、公告等相关内容与文件要求的行为，或发现您有违反本协议约定的行为，或发现您有违反您与易派客签署的其他相关用户协议的约定的行为，易派客有权视情况暂停或终止您继续使用易物流相关服务。因前述原因产生的一切损失由您自行承担，易派客不承担任何责任。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">2.8 您充分理解并</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">明确</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >同意：易派客一旦发现您有违反易派客电子商务平台或易物流的各项规则、政策、声明、公告等相关内容与文件要求的行为，或发现您有违反本协议约定的行为，或发现您有违反您与易派客签署的其他相关用户协议的约定的行为，易派客有权通知自身的合作机构，暂停对您提供有关服务。易派客有权将您的违约、违规行为信息以及其他依据法律法规应当予以公示的您的违法行为信息在易派客电子商务平台或易物流上予以公示。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >2.9
        您充分理解并认可：易派客与您及物流服务商/承运人均不存在任何代理、挂靠或雇佣关系。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >2.10
        您充分理解并认可：易派客作为平台方，仅为您提供普通货物运输业务的网络交易撮合、信息发布等平台服务，并不直接介入您与物流服务商/承运人之间具体的货物运输交易，您与物流服务商/承运人之间因货物运输交易所产生的任何纠纷或责任，均与易派客无关。您在使用易物流开展货物运输交易过程中所产生的与任何第三方的纠纷或责任，均应由您自行解决并承担因此产生的全部责任。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 黑体;
        color: rgb(0, 0, 0);
        font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="黑体">三、</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 黑体;
        color: rgb(0, 0, 0);
        font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="黑体">账号和密码</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 黑体;
        color: rgb(0, 0, 0);
        font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      >&nbsp;</span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 黑体;
        color: rgb(0, 0, 0);
        font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >3.1
        您充分理解并同意：您应妥善保管用于登录易派客电子商务平台、易物流的账号名称及密码、用于收付相关款项的银行卡卡号、密码、有效期等银行卡信息和在线收付软件（包括但不限于“在线支付”）的用户名及支付密码（包括但不限于数字密码）。您确认并同意默认任何使用您的电脑终端、移动终端、用户账号名称及密码的人员均是您或经您授权使用的人员。您应确保您用于使用易派客电子商务平台、易物流的电脑终端、移动终端设备在安全、未被病毒袭击、未被入侵、未被监控、未被非法控制的环境下运行和使用。您不得以任何形式出借、出租、转让您的前述账号、密码或其他信息，您应确保您在易物流获取的服务仅供自身使用。如您因任何原因泄露了上述信息中的任意一项、被其他人恶意利用前述信息中的任意一项或遗失前述终端设备，由此产生的风险和遭受的全部损失应由您自行承担，如因此致使易派客遭受任何损失的，您应赔偿易派客所遭受的全部损失。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >3.2
        您充分理解并同意：易派客对您账号的实际使用人/操作人与账号的注册人/申请人之间的关系不具有核查义务，任何通过您账号登录、使用易物流的行为均应视同为您的行为，由您自行承担因该等行为而产生的一切责任。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >3.3
        您充分理解并同意：您账号的暂停、中止、终止使用均不代表您责任的终止，而无论该等暂停、中止、终止使用是由于何种原因造成。您在账号暂停、中止、终止使用后，仍需对您使用易物流期间的行为承担可能产生的一切责任。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      margin-left: 0pt;
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 黑体;
        color: rgb(0, 0, 0);
        font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="黑体">四、权利与义务</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 黑体;
        color: rgb(0, 0, 0);
        font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >4.1您在使用易物流时，应严格遵守中华人民共和国各项法律法规</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">规章以及</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">政策</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">等规范性文件要求，并应严格遵守</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >《易物流云平台运营规则》等易派客电子商务平台和易物流的各项规则、政策、声明、公告等相关内容与文件要求以及本协议约定以及您与易派客签署的相关用户协议约定，承诺并保证自身在使用易物流前，已知悉并履行所有可适用的国家相关法律法规、企业内部管理制度要求，不得通过易物流</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">发布危险化学品等危险物品、赃物以及</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">法律法规所禁止运输的货物</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">的运输需求</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >，不得通过易物流开展危险化学品等危险</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">物品</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >、赃物以及法律法规所禁止运输的货物运输业务，对运输条件有法定要求的</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">货物应</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >选择具备合法运输条件的承运人开展运输，并应确保运输货物的合法性、真实性。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >前款所称的货物，应是您依法有权处置的物品或者财产。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >4.2
        您在使用易物流发布发运单时，即视为您已知悉并同意易派客将向物流服务商/承运人提供您向易派客所提交的各类用户信息，以便对方通过易物流开展订单接收、选择、查询、报价、抢单等相关活动。
      </font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >4.3
        您在使用易物流时，应对发布的货源信息进行如实、详细地描述，确保实际运输货物与发布的货源信息一致。因您发布的货源信息与实际运输货物情况发生偏差导致的任何纠纷，均由您自行负责处理并承担一切责任，与易派客无关。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >4.4
        您有权使用车货匹配功能，通过易物流自主发布物流需求。您在使用易物流车货匹配功能时，可自行选择发运单的发布模式。发运单的发布模式分为询价和抢单。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >4.5
        对于询价模式，您在接收物流服务商报价后，应当自行对物流服务商提供的各类报价信息进行核实，自行选择、决定物流服务商作为承运人与其开展后续的货物运输合作。您选定相应物流服务商作为承运人的行为，即视为对其报价信息的接受。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >在您设定的报价时间内，如物流服务商已作出的报价不符合您的预期，您可要求相关物流服务商重新报价。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">在您设定的报价时间内，如您接受</font
      ><font face="仿宋_GB2312"
        >/认可任一物流服务商报价时，即可提前作出揭示报价，并视为已选择、决定该物流服务商作为承运人，与之开展后续的货物运输合作。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >4.6
        对于询价模式，您在发布发运单后，如尚无物流服务商报价，则可撤销相关发运单，自行决定是否再次组织询价、抢单。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >4.7
        对于抢单模式，您在发布发运单后，由最先响应并成功抢单的物流服务商获得承运人资格，与您开展后续的货物运输合作。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >4.8
        您有权禁止您已停止货物运输业务合作的物流服务商参与您组织的询价或抢单。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >4.9
        您需自行与通过询价、抢单确定的承运人开展后续的货物运输合作对接，签署相关运输协议，根据与承运人达成的协议，将运输货物交付承运人，由承运人按照协议要求，完成货物运输。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >4.10
        您与物流服务商/承运人之间因货物运输合作产生的任何争议、纠纷，应由您双方自行协商解决，易派客不承担任何责任。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >4.11 您不得利用易物流以及从易物流所获取的信息从事任何非法行为。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >4.12 您不得擅自利用易物流其他用户的数据信息赚取私利。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >4.13
        如您收取货款后存在不按约定交货等不诚信行为，造成收货方或其他第三方损失的，由您承担全部责任，与易派客无关，且易派客有权取消您对于易物流的使用资格。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >如易派客因您的前述行为遭受损失，您还应当赔偿易派客因此所遭受的全部损失。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >4.14
        如您对物流服务商/承运人以外的其他第三方负有按时交付货物等履约义务的，由您自行负责相关履约时效。易派客作为平台运营方，不承担您前述的履约时效责任。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28.1pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">4.15您保证您向易派客提供的</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">以及</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">您使用易派客电子商务平台</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">、</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">易物流所发布、形成的各类</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">数据信息</font
        ><font face="仿宋_GB2312">(数据信息</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">形式</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312"
          >包括但不限于数字、文本、图像、影像</font
        ></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">；</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">内容包括但不限于</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">用户信息、</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">运输货源</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">发布</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">方发布</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">的抢单定价信息</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">；</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">下同</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312"
          >)均是合法、真实、准确、完整、有效的。您承诺您拥有该等数据信息的所有权或经第三方授权后的使用权</font
        ></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">等合法权利</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">，且您有权</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">允许</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">易派客</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">将该等信息</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">作本协议约定之用，</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">而</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312"
          >不会因此造成易派客被第三方追究责任以及索赔等情况。由于您</font
        ></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">提供、</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">发布</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">、</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">形成</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">的</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">前述</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">数据信息或授权易派客</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">作本协议约定之用的</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">数据信息</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">存在</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">不真实</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">、</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">不准确、违法违规等违反本协议约定的情形及</font
        ><font face="仿宋_GB2312">/或</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">侵害</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">了</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">第三方</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">合法</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312"
          >权益而造成的全部法律后果均由您自行负责</font
        ></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">，</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312"
          >如造成易派客损失，您应承担全部赔偿责任</font
        ></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">。</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><o:p></o:p></span
    ></b>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28.1pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312"
          >4.16您通过本协议予以确认：对于您向易派客提供的</font
        ></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">以及您</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">使用易派客电子商务平台</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">、</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">易物流所发布</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">、</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312"
          >形成的各类数据信息，易派客均有权下载、收集、存储、复制、分析、编辑、处理、使用，并有权以易派客电子商务平台各项业务开展的必要为限向易派客电子商务平台的供应商、采购商、平台采购管家、易派客在中石化系统内的关联公司、易派客的合作伙伴</font
        ></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">〔</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312"
          >包括但不限于易派客的专业顾问机构、为易物流云平台提供系统运维、研（开）发服务的合作伙伴</font
        ></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">〕</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312"
          >等主体共享上述数据信息。上述数据信息的分析、编辑、处理成果归易派客所有。</font
        ></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><o:p></o:p></span
    ></b>
  </p>
  <p
    class="MsoNormal"
    style="
      margin-left: 21pt;
      mso-para-margin-left: 2gd;
      text-indent: 0pt;
      mso-char-indent-count: 0;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 黑体;
        color: rgb(0, 0, 0);
        font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="黑体">五、保密约定</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 黑体;
        color: rgb(0, 0, 0);
        font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >5.1
        您承诺对本协议及您在接受易物流服务过程中签署的其他协议中所约定属于保密信息的内容负有保密义务，未经易派客书面授权，不得将保密信息以任何方式提供给第三方，不得将保密信息用于与本合作无关的活动、宣传，不得利用保密信息与披露方以外的第三方从事商业交易，但您与易派客另有约定的除外。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >您了解并同意，易派客有权根据法律法规的规定，或是应司法机关、政府有关部门的要求，或是基于依法依规开展的内部审计、检查、巡察等工作需要以及为开展投标工作需要而在必要范围内向有关第三方提供相关保密信息。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >本协议终止时，您所掌握的所有保密信息及其复制件，无论其为电子或书面等任何形式，均应</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">按易派客提出的要求进行相应处理</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >。本条约定的保密义务在本协议终止后仍然有效。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >5.2
        本协议约定的保密信息是指：在您与易派客的沟通交流过程中，一方以书面或口头等方式向对方提供的通讯、信息、产品、数据、设计、图纸等资料，包括但不限于商业计划、贸易数据、财务数据、生产经营、专有技术、研究成果、技术秘密等。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >5.3 以下各项不属于本协议所称“保密信息”：</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">（</font
      ><font face="仿宋_GB2312"
        >1）在本协议签订时已为一方合法获取的信息；</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">（</font
      ><font face="仿宋_GB2312"
        >2）在本协议签订时已为公众所知的信息；</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">（</font
      ><font face="仿宋_GB2312"
        >3）一方从不承担保密义务的第三方所获取的信息，并且以一方所了解为限，该第三方对该等信息的获取和/或披露不是非法的；</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      margin-left: 0pt;
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">（</font
      ><font face="仿宋_GB2312"
        >4）在没有接触保密信息的情况下，一方独立开发取得的信息；</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      margin-left: 0pt;
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">（</font
      ><font face="仿宋_GB2312"
        >5）一方事先征得另一方书面同意而发布的信息。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >5.4
        如您作为保密信息的披露方应确保您向易派客提供的保密信息是您有权提供的，不会侵犯任何第三方的合法权益。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      margin-left: 0pt;
      mso-para-margin-left: 0gd;
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 黑体;
        color: rgb(0, 0, 0);
        font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="黑体">六、</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 黑体;
        color: rgb(0, 0, 0);
        font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="黑体">违约责任</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 黑体;
        color: rgb(0, 0, 0);
        font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >6.1 您在使用易物流过程中，如存在违反中华人民共和国各项法律法规</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">规章以及</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">政策</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">等规范性文件要求</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >的行为，或存在违反《易物流云平台运营规则》等易派客电子商务平台和易物流的各项规则、政策、声明、公告等相关内容与文件要求的行为，或存在违反本协议约定或您与易派客签署的相关用户协议约定的行为，均视为您违约，易派客有权要求您承担相应责任，并要求您赔偿易派客遭受的全部损失。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 黑体;
        color: rgb(0, 0, 0);
        font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="黑体">七、终止服务的特别约定</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 黑体;
        color: rgb(0, 0, 0);
        font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28.1pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312"
          >7.1
          您在使用易物流过程中，不得出现下列行为，否则易派客有权立即终止向您提供易物流相关服务并</font
        ></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">单方解除</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312"
          >本协议，还有权要求您赔偿易派客因此而遭受的全部损失并承担相关法律责任：</font
        ></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><o:p></o:p></span
    ></b>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">（</font
      ><font face="仿宋_GB2312"
        >1）利用易物流对他人造成人身、财产损害的行为；</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">（</font
      ><font face="仿宋_GB2312"
        >2）违反法律法规、强制性国家标准要求、社会公序良俗的行为；</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">（</font
      ><font face="仿宋_GB2312"
        >3）通过任何手段、任何方式自行或者委托他人进行虚拟交易、虚拟验证、自买自卖、伪造网络用户真实消费/体验以及从事刷单、伪造、仿冒等违背本协议商业目的或违反法律法规的不实行为；</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">（</font
      ><font face="仿宋_GB2312">4）违反本协议保密约定的行为；</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">（</font
      ><font face="仿宋_GB2312"
        >5）违反本协议关于知识产权方面应当遵守的义务的行为；</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">（</font
      ><font face="仿宋_GB2312">6）其他</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">导致本协议目的无法实现的严重违约行为及</font
      ><font face="仿宋_GB2312">/或</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >严重损害易派客或其他用户利益的行为。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28.1pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312"
          >7.2易派客有权根据自身商业安排经过合理的提前通知终止易物流的所有服务及本协议。</font
        ></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><o:p></o:p></span
    ></b>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28.1pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312"
          >7.3请您注意，易物流服务及本协议的终止将仅使您无法继续使用易物流，不影响您通过易物流与任何用户所达成之合同的效力</font
        ></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">，</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">您</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">应自行</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">负责解决因前述合同引发的相关问题</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">并承担因此产生的一切法律责任。</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><o:p></o:p></span
    ></b>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 0pt;
      mso-char-indent-count: 0;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      >&nbsp;&nbsp;&nbsp;&nbsp;</span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 黑体;
        color: rgb(0, 0, 0);
        font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="黑体">八、易派客的其他权利及义务</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 黑体;
        color: rgb(0, 0, 0);
        font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28.1pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312"
          >8.1&nbsp;易派客设立客服电话，负责解答您在使用易物流过程中遇到的各种疑问（客服电话：4009-945-958）。</font
        ></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><o:p></o:p></span
    ></b>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >8.2&nbsp;您了解并同意，易派客有权应国家有权机关（包括但不限于行业主管部门、司法机关等）的要求，向其提供您在易物流的个人信息、交易记录等必要信息。如您涉嫌侵犯他人合法权益，则易派客有权在初步判断涉嫌侵权行为可能存在的情况下，在必要范围内向权利人提供您的相关信息。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >8.3为更好地为您提供本服务，易派客将不时进行易物流进行维护和升级。您同意，在系统维护及升级过程中产生的业务中断或不稳定状态，不视为易派客违约。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 黑体;
        color: rgb(0, 0, 0);
        font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="黑体">九、</font>&nbsp;免责条款</span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 黑体;
        color: rgb(0, 0, 0);
        font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >9.1您在使用易物流过程中，接收的物流服务商/承运人/其他用户的相关信息内容，均系物流服务商/承运人/其他用户自行提供，易派客已明确要求各信息提供者对其所提供信息内容的真实性、合法性、准确性、有效性负责。易派客对信息内容的真实性、合法性、准确性、有效性不提供任何保证，亦不承担任何责任，对此您应谨慎判断。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28.1pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312"
          >9.2
          由于互联网可能出现不稳定情况，不排除由于发生各种故障（故障原因包括但不限于网络故障、电路故障、系统故障、计算机或网络服务器及相关设备等故障）或遭到计算机病毒侵袭或被网络黑客攻击等原因，而出现易物流无法正常使用或数据泄露、数据丢失的情况，对由于前述故障或原因以及其他第三方基于前述故障和原因造成易物流无法正常使用或数据泄露、数据丢失而使得您或其他任何第三方遭受到的任何损失，易派客不承担任何责任。</font
        ></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><o:p></o:p></span
    ></b>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28.1pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312"
          >9.3
          对基于不可抗力或其他意外事件而出现易物流无法正常使用的情况或数据泄露、数据丢失以及因其他任何第三方基于前述原因导致易物流无法正常使用或数据泄露、数据丢失，使得您或其他任何第三方所遭受到的任何损失，易派客不承担任何责任。</font
        ></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><o:p></o:p></span
    ></b>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28.1pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312"
          >9.4
          因本协议第9.2条、第9.3条所列的故障及原因造成易物流运行异常的，易派客有权视情况判定该种情形下用户在易物流实施的相关行为是否有效。相关用户有权在收到易派客所做的判定结果之日起3个工作日内向易派客电子商务平台客服提交异议，提交异议方式如下：</font
        ></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><o:p></o:p></span
    ></b>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28.1pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">联系电话：</font>
        <font face="仿宋_GB2312">400-819-8786</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><o:p></o:p></span
    ></b>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28.1pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">邮箱：</font
        ><font face="仿宋_GB2312">EASY-PEC@sinopec.com</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><o:p></o:p></span
    ></b>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28.1pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312"
          >9.5 您在使用易物流相关服务的过程中，易派客不对下列风险担责：</font
        ></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><o:p></o:p></span
    ></b>
  </p>
  <p
    class="MsoNormal"
    style="
      margin-left: 0pt;
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">（</font
      ><font face="仿宋_GB2312">1）&nbsp;您或其他第三方操作不当；</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      margin-left: 0pt;
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">（</font
      ><font face="仿宋_GB2312"
        >2）&nbsp;您通过非易派客授权的方式使用本服务；</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      margin-left: 0pt;
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">（</font
      ><font face="仿宋_GB2312"
        >3）&nbsp;来自他人匿名或冒名的含有威胁、诽谤、令人反感或非法内容的信息；&nbsp;</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      margin-left: 0pt;
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">（</font
      ><font face="仿宋_GB2312"
        >4）&nbsp;遭受他人误导、欺骗或其他导致任何心理、生理上的伤害以及经济上的损失；</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      margin-left: 0pt;
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">（</font
      ><font face="仿宋_GB2312"
        >5）&nbsp;其他因网络信息或您行为引起的风险。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >9.6
        如果您从未经易派客授权的第三方处获取易物流相关服务或者软件，易派客无法保证易物流能够正常使用，由此造成的全部损失，由您自行承担，易派客不承担任何责任。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28.1pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">9.7您或任何第三方在运输</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">及</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312"
          >货物装卸过程中受到的任何人身、财产损害，均与易派客无关，易派客不承担任何责任。</font
        ></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><o:p></o:p></span
    ></b>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >9.8为了改善用户体验、修复漏洞、保障安全性等考虑，易派客有权对易物流不定时进行更新，您应该将相关软件或程序更新至最新版本后使用，否则易派客将不保证您能正常使用易物流。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 黑体;
        color: rgb(0, 0, 0);
        font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="黑体">十、</font>&nbsp;信息及隐私保护</span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 黑体;
        color: rgb(0, 0, 0);
        font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28.1pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">10.1易派客重视个人信息</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">等数据信息</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">的</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">安全与</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">保护，易派客将依</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">照</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312"
          >国家相关法律法规、易派客电子商务平台《易派客隐私政策》、易物流云平台《易物流云平台注册司机隐私政策》等相关隐私政策对个人信息</font
        ></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">等数据信息</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">进行处理和保护。</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312"
          >《易派客隐私政策》构成本协议不可分割的组成部分，共同适用于您所使用的易物流服务。</font
        ></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><o:p></o:p></span
    ></b>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28.1pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312"
          >10.2您充分理解并明确同意您在使用易物流相关功能或服务过程中所提交的数据信息内可能含有他人的个人信息。对于前述个人信息，您通过本协议向易派客承诺和保证：您向易派客提供的任何数据信息均为有权提供，如涉及他人个人信息的，易派客均有权作出收集、存储、使用、传输、共享、披露等处理行为，且均</font
        ></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312"
          >有权以易派客电子商务平台各项业务开展的必要为限向易派客电子商务平台的供应商、采购商、平台采购管家、易派客在中石化系统内的关联公司、易派客的合作伙伴</font
        ></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">〔</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312"
          >包括但不限于易派客的专业顾问机构、为易物流云平台提供系统运维、研（开）发服务的合作伙伴</font
        ></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">〕</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">等主体共享上述数据信息，</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312"
          >对于前述您向易派客提供他人个人信息以及易派客对该等信息所作处理的行为，您已依法对相关个人履行了法定告知义务，且已取得相关个人符合法定形式的单独同意。否则，</font
        ></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312"
          >由此产生的一切法律责任，由您自行承担。如易派客因您的前述行为遭受损失，您还应当赔偿易派客因此所遭受的全部损失。</font
        ></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        >&nbsp;</span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><o:p></o:p></span
    ></b>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28.1pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312"
          >10.3您充分理解并向易派客作出承诺与保证：您在使用易物流过程中所接触到的易派客所为您提供的他人个人信息，您仅可用于接受易物流相关服务之本身。否则，</font
        ></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312"
          >由此产生的一切法律责任，由您自行承担。如易派客因您的前述行为遭受损失，您还应当赔偿易派客因此所遭受的全部损失。</font
        ></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        >&nbsp;</span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><o:p></o:p></span
    ></b>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 黑体;
        color: rgb(0, 0, 0);
        font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="黑体">十一、知识产权保护</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 黑体;
        color: rgb(0, 0, 0);
        font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >11.1&nbsp;易派客在易物流相关服务中提供的内容（包括但不限于网页、文字、图片、音频、视频、图表等）的知识产权归易派客所有。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >11.2&nbsp;&nbsp;易派客在易物流相关服务中所使用的“易物流”“易物流云平台”“易物流物流商端”“易物流供应商端”等商业标识，其著作权、商标权等知识产权归易派客所有。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >11.3&nbsp;上述知识产权均受到法律保护，未经易派客书面许可，您承诺不应且不应允许或协助任何人以任何形式（包括但不限于通过任何机器人、蜘蛛、截屏等程序或设备）进行使用、出租、出借、分发、展示、复制、修改、链接、转载、汇编、发表、出版、抓取、监视、引用或创造相关衍生作品。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >11.4&nbsp;您充分理解并明确同意：您在使用易物流提供的服务时上传、提交、存储或发布的内容（包括但不限于文字、图片、视频、音频、动画等）的知识产权归属您或您已获合法授权，您的上传、提交、存储或发布行为不会侵犯他人的知识产权或其他合法权益。如果任何第三方提出关于知识产权的异议，易派客有权根据实际情况删除相关的内容，且有权追究您法律责任，如您的相关行为给易派客或任何第三方造成损失的，您应负责全额赔偿。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >11.5在您使用易物流过程中，若因发布、提供的相关内容与第三方发生知识产权争议纠纷，则您负有及时通知易派客的义务，且您应负责及时与第三方协调处理相关争议纠纷，并对相关行为自行负责，您应及时将处理情况和相关问题说明以书面形式提供给易派客。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 微软雅黑;
        mso-bidi-font-family: Helvetica;
        font-size: 8pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 黑体;
        color: rgb(0, 0, 0);
        font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="黑体">十二、其他</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 黑体;
        color: rgb(0, 0, 0);
        font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">12.1</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      >&nbsp;</span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >本协议自您按本协议文首列明的方式确认接受本协议之日起生效。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >12.2
        本协议的签订、效力、履行、终止及其解释适用中华人民共和国（为本协议之目的，不包括香港特别行政区、澳门特别行政区及台湾地区）的法律。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >12.3
        因易派客与您就本协议的签订、履行或解释发生争议，双方应努力友好协商解决。如协商不成，易派客和您均同意由易派客电子商务有限公司所在地有管辖权的人民法院诉讼解决。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28.1pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      text-align: left;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">12.4 </font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312"
          >易派客有权根据国家法律法规变化及运营需要</font
        ></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">不时修改</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">本协议</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">，</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">修改后的协议将在</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">易派客电子商务平台或易物流上</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312"
          >公示七日后生效，自生效之日起，修改后的协议即对您与易派客均具有法律约束力。基于前述情况，您</font
        ></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">应</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312"
          >在公示期内及时查阅并了解前述修改后的协议</font
        ></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 宋体;
          mso-ascii-font-family: 仿宋_GB2312;
          mso-hansi-font-family: 仿宋_GB2312;
          mso-bidi-font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="宋体">内容</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">，</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">若您不</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">接受修改后的协议</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">，</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312"
          >应自修改后的协议公示之日起七日内及时以书面形式向易派客作出明确表示，否则，即表示您已接受修改后的协议，如您与易派客发生争议时，双方将以修改后的协议版本为准。</font
        ></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">若您</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">按前述期限及形式向易派客作出了</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">不</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312"
          >接受修改后的协议的明确表示，则您不可再基于易物流开展新的业务，而</font
        ></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">应</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">及时按照修改</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">前的协议履行完</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">您于易物流</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">未完成</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">的相应</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">责任义务后</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312"
          >再次通知易派客，易派客将就您前述责任义务履行情况进行</font
        ></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312"
          >确认，并将于确认您已履行完相关责任义务后为您关闭易物流使用权限</font
        ></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">，</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">本协议亦将自</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">易物流使用权限关闭</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">时自行终止</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 宋体;
          mso-ascii-font-family: 仿宋_GB2312;
          mso-hansi-font-family: 仿宋_GB2312;
          mso-bidi-font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="宋体">。</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><o:p></o:p></span
    ></b>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">12.</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">5</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      >&nbsp;</span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >如果本协议中任何一条被视为废止、无效或因任何理由不可执行，该条应视为可分的且并不影响任何其余条款的有效性和可执行性。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">12.</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">6</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      >&nbsp;</span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
>本协议未尽事宜，您需遵守易派客电子商务平台或易物流各项规则、政策、声明、公告等相关内容与文件。</font></span> 
  </p>
</div>`

//平台规则
export const platformRuleData = `<div class="Section0" style="layout-grid: 15.6pt">
  <p
    class="MsoNormal"
    align="center"
    style="
      mso-pagination: widow-orphan;
      text-align: center;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 方正小标宋简体;
        color: rgb(0, 0, 0);
        mso-bidi-font-weight: normal;
        font-size: 16pt;
        mso-font-kerning: 0pt;
      "
      ><font face="方正小标宋简体">易物流云平台运营规则</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 方正小标宋简体;
        color: rgb(0, 0, 0);
        mso-bidi-font-weight: normal;
        font-size: 16pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    align="center"
    style="
      mso-pagination: widow-orphan;
      text-align: center;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 黑体;
        color: rgb(0, 0, 0);
        mso-ansi-font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="黑体">第一部分</font> </span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 黑体;
        color: rgb(0, 0, 0);
        mso-ansi-font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="黑体">总则</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 黑体;
        color: rgb(0, 0, 0);
        mso-ansi-font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >1.1
        《易物流云平台运营规则》（以下简称“本规则”）是易派客电子商务平台的运营者易派客电子商务有限公司（以下简称“易派客”）基于相关法律法规，就</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">用户</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">使用易物流云平台（以下简称</font
      ><font face="仿宋_GB2312"
        >“易物流”）时所应遵守的基本程序与要求制定的规范。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >1.2 易物流用户使用易物流时所涉及的行为适用本规则。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >易物流用户通过易物流从事的一切活动均应遵循公开、公平、公正、诚实信用的原则，依法维护各方主体合法权益。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >1.3 本规则所称的相关术语，除另有约定以外，其定义如下：</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28.1pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">易派客电子商务平台：</font></span
      ></b
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >指由易派客电子商务有限公司运营的工业品电子商务平台，一级域名：</font
      ><font face="仿宋_GB2312">www.epec.com。</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28.1pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">易物流云平台：</font></span
      ></b
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >指由易派客电子商务有限公司运营的物流管理软件系统（含</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">网页</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">端和移动端）。</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28.1pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">用户：</font></span
      ></b
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">指已注册成为易派客电子商务平台会员</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">，</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">有权限使用</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">易物流云平台</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >相关功能和服务的运输货源发布方、物流</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">服务商</font
      ><font face="仿宋_GB2312"
        >/承运人及其他使用易物流云平台的主体。</font
      ></span
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><o:p></o:p></span
    ></b>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28.1pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">车货匹配功能：</font></span
      ></b
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >系易派客电子商务有限公司为使用易物流云平台的用户所提供的平台服务。运输货源发布方可通过易物流云平台车货匹配功能发布发运单，面向选定范围的物流服务商进行询价或由选定范围的物流服务商进行抢单，并从中选定货物承运人，开展后续的货物运输合作。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28.1pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">运输货源发布方：</font></span
      ></b
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >指通过易物流云平台车货匹配功能发布发运单，面向选定范围的物流服务商进行询价或由选定范围的物流服务商进行抢单并从中选定货物承运人，与</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">相应</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >承运人开展后续的货物运输合作的易物流云平台用户。</font
      > </span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28.1pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">物流服务商：</font></span
      ></b
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >指具备相应的货物运输能力，旨在提供货物运输服务的易物流云平台用户。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28.1pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">承运人：</font></span
      ></b
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >指通过易物流云平台车货匹配功能参与运输货源发布方进行的询价或抢单</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">，而</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">被运输货源发布方选定作为货物承运人</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">，</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >与运输货源发布方开展后续的货物运输合作的物流服务商</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">，</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >以及易派客电子商务平台注册的供应商通过易派客电子商务平台编制发货时直接指定作为货物承运人且接单确认的物流服务商。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28.1pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">用户信息：</font></span
      ></b
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">指用户提交给易派客电子商务平台及</font
      ><font face="仿宋_GB2312"
        >/或易物流云平台的、用户通过易派客电子商务平台及/或易物流云平台发布的、易派客电子商务平台及/或易物流云平台通过用户授权的第三方获取的用户相关信息，包括但不限于：用户的名称、电话号码等联系方式；用户的法定代表人/负责人/经营者/授权代表的姓名、电话号码等联系方式、身份证信息、授权委托书等；营业执照、道路运输经营许可证、车辆行驶证、驾驶证等许可、备案证明；车辆信息、货源信息、公司或仓库位置信息、货物运输轨迹信息；用户为申请、使用易派客电子商务平台及/或易物流云平台的合作方所提供的服务而提交的其他相关信息。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28.1pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">个人信息：</font></span
      ></b
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">《易派客隐私政策》中对</font
      ><font face="仿宋_GB2312">“个人信息”的定义和范围适用</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">于</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">本</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">规则</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">。</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28.1pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">车辆信息：</font></span
      ></b
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >指提供货物运输服务的车辆的相关信息，包括但不限于：车牌号、车牌类型、车型、车长、车宽、载重、车辆识别代码、发动机号、车厢信息、车厢体积、车厢长度、拖挂轮轴、车辆轴数信息。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28.1pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">货源信息：</font></span
      ></b
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">指与</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">运输</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >货物相关的信息，包括但不限于：货物名称、货物规格型号、总重量、重量单位、货物类型、货值单价、发货地址、收货地址、货物类型、发货时间、收货时间、货物体积</font
      ><font face="仿宋_GB2312">/重量/数量、特殊运输要求信息。</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28.1pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">车辆：</font></span
      ></b
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">指物流服务商</font
      ><font face="仿宋_GB2312">/承运人提供货物运输服务的货运车辆。</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28.1pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">注册司机：</font></span
      ></b
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">指物流服务商</font
      ><font face="仿宋_GB2312"
        >/承运人在易物流云平台注册的本单位具有依法从事货物运输业务相关资质，能够驾驶货运车辆提供货物运输服务的自然人。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >1.4 用户应严格按照易派客电子商务平台和易物流</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">的</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >各项规则、政策、声明、公告等内容与文件的要求以及</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">用户</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">与</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">易</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">派客签署的相关用户协议</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">约定</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >使用易物流。用户如违反前述规定，造成易派客、其他用户或任何第三方损失的，应向受损害方承担全部赔偿责任。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >1.5
        用户应妥善保管用于登录易派客电子商务平台、易物流的账号名称及密码、用于收付相关款项的银行卡卡号、密码、有效期等银行卡信息和在线收付软件（包括但不限于“在线支付”）的用户名及支付密码（包括但不限于数字密码）。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >1.6
        用户应确保任何使用自身电脑终端、移动终端及自身的易派客电子商务平台、易物流账号名称及密码的人员均是自身或经自身授权使用的人员，并应确保用于使用易派客电子商务平台、易物流的电脑终端、移动终端设备在安全、未被病毒袭击、未被入侵、未被监控、未被非法控制的环境下运行和使用。用户不得以任何形式</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">出借</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >、出租、转让前述账号、密码或其他信息</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">，</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">并应确保</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">在易物流获取的服务仅供自身使用。</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >用户因任何原因泄露前款所涉信息中的任意一项、被他人恶意利用前款所涉信息中的任意一项或遗失相关终端设备，所产生的风险以及遭受的全部损失均由该用户自行承担，如因此导致易派客遭受损失的，该用户还应赔偿易派客所遭受的全部损失。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >1.7
        易派客对用户账号的实际使用人/操作人与账号注册人/申请人之间的关系不具有核查义务。任何通过用户账号登录、使用易物流的行为均视为该账号注册人/申请人的行为，由该账号注册人/申请人自行承担因此产生的一切责任。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >1.8
        用户账号的暂停、中止、终止使用均不代表用户责任的终止，而无论该等暂停、中止、终止使用是由于何种原因造成的。用户在账号暂停、中止、终止使用后，仍需对自身使用易物流期间的行为承担可能产生的一切责任。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">1.9 易派客作为平台方，仅为用户提供</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">普通</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >货物运输业务的网络交易撮合、信息发布等</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">平台服务</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >，并不直接介入用户之间具体的货物运输交易</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">。</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >用户因货物运输交易所产生的任何纠纷或责任，均与易派客无关。用户在使用易物流开展货物运输交易过程中所产生的与任何第三方的纠纷或责任，均应由相关用户自行解决并承担因此产生的全部责任。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >1.10
        对于需付费的易物流相关服务，易派客有权收取平台服务费用并有权单方面确定、调整具体的收费标准、收费方式等付费要求。易派客可能会给予用户一定的免费体验付费服务的次数或期限，但易派客有权根据运营需要或使用情况等原因随时终止免费体验。免费体验终止后，用户如需继续使用该付费服务，须按易派客公示的收费标准、收费方式等付费要求购买付费服务后方可继续使用。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >1.11 用户在使用易物流过程中，应严格遵守中华人民共和国各项法律法规</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">规章以及</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">政策</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >等规范性文件要求，并应严格遵守本规则等</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >易派客电子商务平台及易物流的各项规则、政策、声明、公告等相关内容与文件要求以及用户与易派客签署的相关用户协议</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">约定</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">。</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">1.12</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      >&nbsp;</span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >用户不得利用易物流进行任何违法或不正当的活动，不得擅自利用易物流其他用户的数据信息赚取私利。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">1.13</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      >&nbsp;</span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >用户在使用易物流过程中，应当确保所提供及发布的信息合法、真实、有效、完整。否则，相关用户应当就</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">因</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >此造成的损失承担全部赔偿责任，且易派客有权停止向该用户提供任何服务。若用户发布的任何信息不符合易派客电子商务平台或易物流的各项规则、政策、声明、公告等相关内容与文件要求，或不符合用户与易派客签署的相关用户协议</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">约定</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >的，易派客有权视情况要求该用户进行改正、完善、删除或采取其他措施。因用户发布的任何信息给易派客或其他任何第三方造成损失的，该用户应当承担</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">全部</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >赔偿责任，易派客因此而遭受损失的，易派客有权向该用户追偿。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >1.14
        用户在使用易物流过程中，接收的运输货源发布方/物流服务商/承运人</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >/其他用户/易派客电子商务平台注册供应商</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">的相关信息</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">内容</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">，均系该运输货源发布方</font
      ><font face="仿宋_GB2312">/物流服务商/承运人</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >/其他用户/易派客电子商务平台注册供应商</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >自行提供，易派客已明确要求各信息提供者对其所提供信息内容的真实性、合法性、准确性、有效性负责。易派客对信息内容的真实性、合法性、准确性、有效性不提供任何保证，亦不承担任何责任，对此用户应谨慎判断。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >1.15
        易派客有权根据易派客电子商务平台、易物流的各项规则、政策、声明、公告等相关内容与文件要求、用户与易派客签署的相关协议约定、国家相关法律法规</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">规章以及</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">政策</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">等规范性文件要求</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >、有权部门的要求，要求用户进一步提供相关信息，相关用户应予以积极配合。如相关用户未能积极配合或未能及时提供前述信息，易派客有权立即暂停或终止向该用户提供部分或全部易物流服务，并由该用户自行承担因此所造成一切损失，易派客不承担任何责任。</font
      ><font face="仿宋_GB2312">&nbsp;</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28.1pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312"
          >1.16
          由于互联网可能出现不稳定情况，不排除由于发生各种故障（故障原因包括但不限于网络故障、电路故障、系统故障、计算机或网络服务器及相关设备等故障）或遭到计算机病毒侵袭或被网络黑客攻击等原因，而出现易物流无法正常使用</font
        ></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">或数据泄露、数据丢失</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312"
          >的情况，对由于前述故障或原因以及其他第三方基于前述故障和原因造成易物流无法正常使用</font
        ></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">或数据泄露、数据丢失</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312"
          >而使得用户或其他任何第三方遭受到的任何损失，易派客不承担任何责任。</font
        ></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><o:p></o:p></span
    ></b>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28.1pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312"
          >1.17 对基于不可抗力或其他意外事件而出现易物流无法正常使用</font
        ></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">或数据泄露、数据丢失</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">的情况以及因其他任何第三方基于</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">前述原因</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">导致易物流无法正常使用</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">或数据泄露、数据丢失</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312"
          >，使得用户或其他任何第三方所遭受到的任何损失，易派客不承担任何责任。</font
        ></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><o:p></o:p></span
    ></b>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28.1pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312"
          >1.18 因本规则第1.16条、第1.17条所列的故障及原因造成易物流</font
        ></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">运行异常</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312"
          >的，易派客有权视情况判定该种情形下用户在易物流实施的相关行为是否有效。相关用户有权在收到易派客所做的判定结果之日起</font
        ><font face="仿宋_GB2312"
          >3个工作日内向易派客电子商务平台客服提交异议，提交异议方式如下：</font
        ></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><o:p></o:p></span
    ></b>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28.1pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">联系电话：</font
        ><font face="仿宋_GB2312">400-819-8786</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><o:p></o:p></span
    ></b>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28.1pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">邮箱：</font></span
      ></b
    ><span
      ><a href="mailto:EASY-PEC@sinopec.com"
        ><b
          ><span
            style="
              mso-spacerun: 'yes';
              font-family: 仿宋_GB2312;
              color: rgb(0, 0, 0);
              font-weight: bold;
              font-size: 10pt;
              mso-font-kerning: 0pt;
            "
            ><font face="仿宋_GB2312">EASY-PEC@sinopec.com</font></span
          ></b
        ></a
      ></span
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><o:p></o:p></span
    ></b>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28.1pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">1.1</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">9 </font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312"
          >用户在使用易物流过程中，易派客不对下列风险担责：</font
        ></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><o:p></o:p></span
    ></b>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">（</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">1</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">）</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">用户或其他第三方操作不当；</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">（</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">2</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">）</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >用户通过非易派客授权的方式使用易物流</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">；</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      text-align: left;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">（</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">3</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">）</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >来自他人匿名或冒名的含有威胁、诽谤、令人反感或非法内容的信息；</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">（</font><font face="仿宋_GB2312">4</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">）</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >遭受他人误导、欺骗或其他导致任何心理、生理上的伤害以及经济上的损失；</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">（</font
      ><font face="仿宋_GB2312"
        >5）其他因网络信息或用户自身行为引起的风险。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >1.20
        如果用户从未经易派客授权的第三方处获取易物流相关服务或者软件，易派客无法保证易物流能够正常使用，由此造成的全部损失，由该用户自行承担，易派客不承担任何责任。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28.1pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">1.21 用户或任何第三方在运输</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312">及</font></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><font face="仿宋_GB2312"
          >货物装卸过程中受到的任何人身、财产损害，均与易派客无关，易派客不承担任何责任。</font
        ></span
      ></b
    ><b
      ><span
        style="
          mso-spacerun: 'yes';
          font-family: 仿宋_GB2312;
          color: rgb(0, 0, 0);
          font-weight: bold;
          font-size: 10pt;
          mso-font-kerning: 0pt;
        "
        ><o:p></o:p></span
    ></b>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >1.22
        为了改善用户体验、修复漏洞、保障安全性等考虑，易派客有权对易物流不定时进行更新，用户应该将相关软件或程序更新至最新版本后使用，否则易派客将不保证用户能正常使用易物流。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    align="center"
    style="
      mso-pagination: widow-orphan;
      text-align: center;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 黑体;
        color: rgb(0, 0, 0);
        mso-ansi-font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="黑体">第二部分</font>
      <font face="黑体">运输货源发布方</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 黑体;
        color: rgb(0, 0, 0);
        mso-ansi-font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >2.1
        运输货源发布方应与易派客签署《易物流云平台用户服务协议》，并严格遵守该协议的有关约定、本规则及易派客电子商务平台、易物流的各项规则、政策、声明、公告等相关内容与文件要求及自身与易派客签署的其他相关用户协议</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">约定</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >，承诺并保证自身在使用易物流前，已知悉并履行所有可适用的国家相关法律法规、企业内部管理制度要求；运输货源发布方在使用易物流时，应自觉严格遵守中华人民共和国各项法律法规规章以及政策等规范性文件要求，不得通过易物流发布危险化学品等危险物品、赃物以及法律法规所禁止运输的货物的运输需求，不得通过易物流</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">运输</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >危险化学品等危险物品、赃物以及法律法规所禁止运输的货物，对运输条件有法定要求的</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">货物应</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >选择具备合法运输条件的承运人开展运输，并应确保运输货物的合法性、真实性。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >前款所称的货物，应是运输货源发布方依法有权处置的物品或者财产。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">2.2</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      >&nbsp;</span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >当运输货源发布方使用易物流发布发运单时，即视为已知悉并同意易派客将向物流服务商</font
      ><font face="仿宋_GB2312"
        >/承运人提供自身向易派客所提交的各类用户信息，以便</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">对方</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >通过易物流开展订单接收、选择、查询、报价、抢单等相关活动。</font
      > </span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >2.3
        运输货源发布方在使用易物流时，应对发布的货源信息进行如实、详细</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">地</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >描述，确保实际运输货物与发布的货源信息一致。因运输货源发布方发布的货源信息与实际运输货物情况发生偏差导致的任何纠纷，均由运输货源发布方自行负责处理并承担一切责任，与易派客无关。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >2.4
        运输货源发布方在使用易物流车货匹配功能时，可自行选择发运单的发布模式。发运单的发布模式分为询价和抢单。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >2.5
        对于询价模式，运输货源发布方在接收物流服务商报价后，应当自行对物流服务商提供的各类报价信息进行核实，自行选择、决定</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">物流服务商作为</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >承运人与其开展后续的货物运输合作。运输货源发布方选定相应物流服务商作为承运人的行为，即视为对其报价信息的接受。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">在运输货源发布方设定的报价时间内，</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >如物流服务商已作出的报价不符合运输货源发布方预期，运输货源发布方可要求相关物流服务商重新报价。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >在运输货源发布方设定的报价时间内，如</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">运输货源发布方接受</font
      ><font face="仿宋_GB2312"
        >/认可任一物流服务商报价时，即可提前作出揭示报价，并视为已选择、决定该物流服务商作为承运人，与之开展后续的货物运输合作</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">。</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >2.6
        对于询价模式，运输货源发布方在发布发运单后，如尚无物流服务商报价，则可撤销相关发运单，自行决定是否再次组织询价、抢单。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >2.7
        对于抢单模式，运输货源发布方发布发运单后，由最先响应并成功抢单的物流服务商获得承运人资格，与运输货源发布方开展后续的货物运输合作。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >2.8
        运输货源发布方有权禁止其已停止货物运输业务合作的物流服务商参与自身组织的询价或抢单。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >2.9
        运输货源发布方需自行与通过询价、抢单确定的承运人开展后续的货物运输合作对接，签署相关运输协议，根据与承运人达成的协议，将运输货物交付承运人，由承运人按照协议要求，完成货物运输。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >2.10
        运输货源发布方与物流服务商/承运人之间因货物运输合作产生的任何争议、纠纷，应由其双方自行协商解决，易派客不承担任何责任。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >2.11
        运输货源发布方不得利用易物流以及从易物流所获取的信息从事任何非法行为。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >2.12
        运输货源发布方如收取货款后存在不按约定交货等不诚信行为，造成收货方或其他第三方损失的，由该运输货源发布方承担全部责任，与易派客无关，且易派客有权取消该运输货源发布方对于易物流的使用资格。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">如易派客因前述行为遭受损失，</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">该运输货源发布方</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >还应当赔偿易派客因此所遭受的全部损失。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >2.13
        运输货源发布方如对物流服务商/承运人以外的其他第三方负有按时交付货物等履约义务的，应自行负责相关履约时效。易派客作为平台方，不承担前述的履约时效责任。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    align="center"
    style="
      mso-pagination: widow-orphan;
      text-align: center;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 黑体;
        color: rgb(0, 0, 0);
        mso-ansi-font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="黑体">第三部分</font>
      <font face="黑体">物流服务商及承运人</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 黑体;
        color: rgb(0, 0, 0);
        mso-ansi-font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >3.1
        物流服务商应与易派客签署《易物流云平台用户服务协议》，物流服务商/承运人应严格遵守该协议的有关约定、本规则及易派客电子商务平台、易物流的各项规则、政策、声明、公告等相关内容与文件要求及自身与易派客签署的其他相关用户协议约定，承诺并保证自身在使用易物流前，已知悉并履行所有可适用的国家相关法律法规、企业内部管理制度要求；物流服务商/承运人在使用易物流时，应自觉严格遵守中华人民共和国各项法律法规规章以及政策等规范性文件要求，不得通过易物流运输危险化学品等危险物品、赃物以及法律法规所禁止运输的货物，对运输条件有法定要求的货物应具备合法运输条件方可开展运输，并应依法取得运输相应货物的道路运输资质，并保证资质的合法性、真实性。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
        background: rgb(255, 255, 0);
        mso-highlight: rgb(255, 255, 0);
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >3.2
        物流服务商/承运人申请开通易物流使用权限，即视为知悉并同意易派客将向运输货源发布方/通过易派客电子商务平台编制发货时直接指定货物承运人的易派客电子商务平台注册供应商提供自身向易派客所提交的各类用户信息，以便对方开展报价接收、选择、查询等活动。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >3.3物流服务商/承运人在使用易物流时，应对发布的车辆信息、注册司机信息等承运信息进行如实、详细地描述，确保实际承运能力与发布的承运能力信息一致，因物流服务商/承运人发布的承运信息发生偏差导致的任何纠纷，由物流服务商/承运人负责自行处理并承担一切责任，与易派客无关。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >3.4
        物流服务商/承运人应确保通过易物流开展货物运输服务过程中，提供货物运输服务的车辆均是具备货物运输服务合法资质、证照的货运车辆，并符合国家关于货运车辆的相关要求，且自身对该车辆拥有合法占有和使用的权利，并应确保自身在易物流用户资格保有期间以及通过易物流开展货物运输服务期间，一直维持前述车辆处于合法状态和正常营运及使用状态。因货运车辆技术状况、安全性能等不符合法定要求所造成的一切后果以及引发的相关责任均由物流服务商/承运人自行承担。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >3.5
        物流服务商/承运人应确保提供货物运输服务的注册司机均为年满十八周岁、具有完全民事权利能力和民事行为能力的自然人，具备从事提供货物运输服务的相关能力、资质、证照。因注册司机不具备前述条件而开展货物运输服务所造成的一切后果以及引发的相关责任均由物流服务商/承运人及注册司机自行承担。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >3.6
        物流服务商/承运人应加强对本单位注册司机的日常管理，建立相关管理制度，并加强安全生产教育，确保本单位注册司机依法依规开展货物运输服务。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >3.7
        物流服务商可参与运输货源发布方通过易物流车货匹配功能进行的询价或抢单。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >3.8
        对于询价模式，物流服务商应自行完成对相应发运单中货物运费的合理估价、报价等。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >在运输货源发布方设定的报价时间内，如物流服务商已作出的报价不符合运输货源发布方预期，运输货源发布方可要求相关物流服务商重新报价，物流服务商可以重新报价。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >物流服务商应知悉，在运输货源发布方设定的报价时间内，如</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">运输货源发布方接受</font
      ><font face="仿宋_GB2312"
        >/认可任一物流服务商报价时，即可提前作出揭示报价，并视为已选择、决定该物流服务商作为承运人，与之开展后续的货物运输合作</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">。</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >3.9对于抢单模式，运输货源发布方发布发运单后，物流服务商可及时响应相关发运单，进行抢单操作。最先响应并成功抢单的物流服务商获得该笔发运单的承运人资格。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >3.10
        物流服务商/承运人有权屏蔽其已停止货物运输业务合作的运输货源发布方发布的发运单。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >3.11
        物流服务商除使用易物流车货匹配功能参与运输货源发布方开展的询价、抢单外，也可通过接受易派客电子商务平台注册供应商在易派客电子商务平台编制发货时进行的直接指定，而作为货物承运人开展后续的货物运输合作。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >3.12
        承运人需自行与发布发运单的运输货源发布方/本方已接单确认的通过易派客电子商务平台编制发货时直接指定货物承运人的易派客电子商务平台注册供应商开展后续的货物运输合作对接，签署相关运输协议，根据与对方达成的协议，接收运输货物，并按照协议要求，完成货物运输。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >3.13
        物流服务商/承运人可以通过易物流提供的物流管理功能对易物流以外的线下运输订单进行物流管理。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">3.14 对于根据国家相关规定必须具备</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">卫星定位装置</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">定位功能的车辆，物流服务商</font
      ><font face="仿宋_GB2312">/承运人应确保</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">卫星定位装置</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">定位功能正常使用。</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >3.15
        物流服务商/承运人应确保负责具体承运任务的注册司机在开始及完成相应运输服务任务时，应及时在易物流中录入节点信息及完成相关操作。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >3.16
        物流服务商/承运人与运输货源发布方/通过易派客电子商务平台编制发货时直接指定货物承运人的易派客电子商务平台注册供应商之间因货物运输合作产生的任何争议、纠纷，应由其双方自行协商解决，易派客不承担任何责任。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >3.17
        物流服务商/承运人不得利用易物流以及从易物流所获取的信息从事任何非法行为。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >3.18
        对于物流服务商/承运人收取运费后不按约定运输等不诚信行为，造成运输货源发布方或其他第三方损失的，由该物流服务商/承运人承担全部责任，与易派客无关，且易派客有权取消该物流服务商/承运人对于易物流的使用资格。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">如易派客前述行为遭受损失，</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">该物流服务商</font
      ><font face="仿宋_GB2312">/承运人</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >还应当赔偿易派客因此所遭受的全部损失。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    align="center"
    style="
      mso-pagination: widow-orphan;
      text-align: center;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 黑体;
        color: rgb(0, 0, 0);
        mso-ansi-font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="黑体">第四部分</font>
      <font face="黑体">车货匹配功能使用须知</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 黑体;
        color: rgb(0, 0, 0);
        mso-ansi-font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >4.1 易物流车货匹配功能，分为发运单询价模式和抢单模式。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >用户通过易物流车货匹配功能发布发运单或作出报价、进行抢单时，即视为相关用户已充分知悉并认可易物流仅为普通货物运输业务提供网络交易撮合、信息发布等平台服务。运输货源发布方不得要求物流服务商</font
      ><font face="仿宋_GB2312"
        >/承运人提供任何形式的非货运服务，物流服务商/承运人不得为运输货源发布方提供任何形式的非货运服务。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >4.2
        询价，即由运输货源发布方在发布的发运单中设定报价时间，待物流服务商作出报价后，由运输货源发布方根据报价情况，</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">自行选择、决定</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">物流服务商作为</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">承运人</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">与其开展后续的货物运输合作。</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >4.3
        抢单，即运输货源发布方在发运单中直接给出运费定价，接受该运费定价并最先抢单响应的物流服务商获得承运人资格，与运输货源发布方开展后续的货物运输合作。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >4.4
        使用易物流车货匹配功能的用户应确保在使服务过程中所发布、提供的信息均是合法、真实、准确、完整、有效的信息，且自身为该等信息的有权发布、提供方，并应确保在前述信息发生变更时及时更新，以持续确保所发布、提供的信息的合法性、真实性、准确性、完整性及有效性。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >4.5
        询价模式中，运输货源发布方会收到物流服务商对于询价订单的报价信息。运输货源发布方选定承运人的行为，即视为对上述报价信息的接受。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >4.6
        询价模式中物流服务商发出报价信息的行为以及抢单模式中物流服务商抢单响应的行为，均视为已接受运输货源发布方的运输货物之一切现状和本规则的全部条款，物流服务商应对自己的报价、抢单行为负法律责任，不得在被选定为承运人后以不了解运输货物的实际情况或不了解本规则之全部条款或任一条款为理由，拒绝与运输货源发布方开展后续的货物运输合作。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >4.7
        物流服务商之间不得恶意串通，操纵询价。如出现前述行为，运输货源发布方有权决定违规物流服务商/承运人的询价结果无效并终止其与违规物流服务商/承运人之间的货物运输业务合作。易派客有权取消前述违规物流服务商/承运人在易物流使用车货匹配功能的资格，违规物流服务商/承运人需依有关法律、法规承担责任。</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    align="center"
    style="
      mso-pagination: widow-orphan;
      text-align: center;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 黑体;
        color: rgb(0, 0, 0);
        mso-ansi-font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="黑体">第五部分</font>
      <font face="黑体">附则</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 黑体;
        color: rgb(0, 0, 0);
        mso-ansi-font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">5.1 本规则自2023年11月16日起生效。</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">5.2 本规则解释权归</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">易派客电子商务有限公司</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">所有。</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      mso-pagination: widow-orphan;
      text-align: left;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >5.3
        易派客保留根据需要不时修订本规则或制定补充规则并公示的权利，修订后的规则或相关补充规则将在易派客电子商务平台或</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">易物流上</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >公示七日后生效。自生效之日起，本规则（含修订后的规则或相关补充规则）即对易物流相关各方均具有法律约束力。基于前述情况，用户</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">应</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >在公示期内及时了解和查阅前述修订后的规则或相关补充规则，</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">若</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >用户不接受修订后的规则或相关补充规则</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">，应</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >自前述修订后的规则或相关补充规则公示之日起七日内及时</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">以书面形式向易派客作出明确表示，</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">否则，即表示用户已接受</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">修订后的规则或相关补充规则</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >，如用户与易派客发生争议时，双方将以</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">修订后或经补充后的规则</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">为准。</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">若</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">用户按前述期限及形式向易派客作出了</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">不</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">接受</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">修订后的规则或相关补充规则</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">的明确表示，</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">则</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >用户不可再基于易物流开展新的业务，而</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">应</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">及时</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">按照</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">修订或补充前</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">的</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">规则要求</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">履行完</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">自身</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312"
        >于易物流未完成的相应责任义务后，再次通知易派客，易派客将就</font
      ></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">用户</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">前述责任义务履行情况进行</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">确认</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">，并将于</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">确认用户已履行完相关责任义务后</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">为</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">用户</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">关闭易物流使用权限</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">，</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">用户与</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">易派客签署的《</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">易物流云平台用户服务协议</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">》亦将自其</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">易物流使用权限关闭</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><font face="仿宋_GB2312">时终止。</font></span
    ><span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-weight: normal;
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p></o:p
    ></span>
  </p>
  <p
    class="MsoNormal"
    style="
      text-indent: 28pt;
      mso-char-indent-count: 2;
      line-height: 27pt;
      mso-line-height-rule: exactly;
    "
  >
    <span
      style="
        mso-spacerun: 'yes';
        font-family: 仿宋_GB2312;
        color: rgb(0, 0, 0);
        font-size: 10pt;
        mso-font-kerning: 0pt;
      "
      ><o:p>&nbsp;</o:p></span
    >
  </p>
</div>`

